<template>
  <section
    v-if="showSection"
    data-qa="analyses_lpu_cards_section"
    class="analyses-lpu-cards-section d-flex flex-column ga-6 min-w-0 w-100"
  >
    <h2
      :id="LPU_CARDS_SECTION_ANCHOR"
      data-qa="analyses_lpu_cards_title"
      class="text-h6 text--text mb-0"
      :class="{ 'container': isMobile }"
    >
      Где сдать анализы в {{ townNamePred }}
    </h2>

    <LpuCardsChips
      v-if="context.feature_flags.ff_analyses_filters"
      :class="{ 'container': isMobile }"
      :applied-sort="appliedSort"
      :applied-online-order="appliedOnlineOrder"
      :applied-with-discount="appliedWithDiscount"
      :applied-place="appliedPlace"
      :apply-loading="isFiltersApplying"
      @apply="applyFilters"
      @request-error="openRequestErrorDialog"
    />

    <LpuCardsNotFound
      v-if="showNotFound"
      :class="{ 'container': isMobile }"
    />

    <template v-else>
      <div class="d-flex flex-column ga-4">
        <template v-if="showInitialExtras">
          <template v-if="ff_update_spec_design_lpus">
            <div
              v-if="specialPlacementLpuCards.length"
              data-qa="analyses_lpu_cards_special_placement"
              class="analyses-lpu-cards-special-placement d-flex flex-column ga-2"
            >
              <div
                data-qa="analyses_lpu_cards_special_placement_label"
                class="pl-4 text-caption text-warning--text text-no-wrap"
              >
                Спецразмещение
              </div>
              <AnalysesCard
                v-for="card in specialPlacementLpuCards"
                :key="`placement-${card.id}`"
                :card="card"
              />
            </div>
            <AnalysesCard
              v-for="card in partnerExtraCards"
              :key="`placement-${card.id}`"
              :card="card"
            />
          </template>
          <template v-else>
            <AnalysesCard
              v-for="card in specialPlacementCards"
              :key="`placement-${card.id}`"
              :card="card"
            />
          </template>
        </template>

        <AnalysesCard
          v-for="card in pageCards"
          :key="card.id"
          :card="card"
        />
      </div>

      <LinkPagination
        v-if="showPagination"
        data-qa="analyses_lpu_cards_pagination"
        :current-page="currentPage"
        :page-range="pageRange"
        :has-previous="hasPrevious"
        :has-next="hasNext"
        :previous-page-number="previousPageNumber"
        :next-page-number="nextPageNumber"
        :get-href="getPageHref"
        fetch-on-select
        @select="goToPage"
      />
    </template>

    <LpuCardsRequestErrorDialog
      v-model="isRequestErrorDialogOpen"
      :error="requestError"
    />
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AnalysesCard from 'src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/AnalysesCard.vue'
import LpuCardsChips from 'src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsChips.vue'
import LpuCardsNotFound from 'src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsNotFound.vue'
import LpuCardsRequestErrorDialog
  from 'src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsRequestErrorDialog.vue'
import useAnalysesLpuCardsSection
  from 'src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/_composables/useAnalysesLpuCardsSection'
import LinkPagination from 'src/components/common/LinkPagination/LinkPagination.vue'
import { LPU_CARD_TYPE } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'

const {
  LPU_CARDS_SECTION_ANCHOR,
  context,
  isMobile,
  townNamePred,
  appliedSort,
  appliedOnlineOrder,
  appliedWithDiscount,
  appliedPlace,
  isFiltersApplying,
  showInitialExtras,
  showNotFound,
  showSection,
  specialPlacementCards,
  pageCards,
  showPagination,
  currentPage,
  pageRange,
  hasPrevious,
  hasNext,
  previousPageNumber,
  nextPageNumber,
  getPageHref,
  isRequestErrorDialogOpen,
  requestError,
  applyFilters,
  goToPage,
  openRequestErrorDialog,
} = useAnalysesLpuCardsSection()

const ff_update_spec_design_lpus = computed(() => (
  Boolean(context.feature_flags.ff_update_spec_design_lpus)
))

const specialPlacementLpuCards = computed(() => (
  specialPlacementCards.value.filter(card => card.cardType === LPU_CARD_TYPE.LPU)
))

const partnerExtraCards = computed(() => (
  specialPlacementCards.value.filter(card => card.cardType === LPU_CARD_TYPE.PARTNER)
))
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.analyses-lpu-cards-special-placement {
  padding: 8px 4px 4px;
  overflow: hidden;
  background-color: $ui-kit-bg-warning;
  border-radius: 24px 24px 28px 28px;
}
</style>
